import { render, staticRenderFns } from "./thisOrganization.vue?vue&type=template&id=16943c90"
import script from "./thisOrganization.vue?vue&type=script&lang=js"
export * from "./thisOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports